import { Routes } from '@angular/router';
import { AccountLayoutPage } from './pages/account/account-layout-page/account-layout-page';
import { AccountOrdersPage } from './pages/account/account-orders-page/account-orders-page';
import { AccountProfilePage } from './pages/account/account-profile-page/account-profile-page';
import { LoginPage } from './pages/auth/login-page/login-page';
import { ResetPasswordPage } from './pages/auth/reset-password-page/reset-password-page';
import { SignupPage } from './pages/auth/signup-page/signup-page';
import { SignupSentPage } from './pages/auth/signup-sent-page/signup-sent-page';
import { SignupVerificationPage } from './pages/auth/signup-verification-page/signup-verification-page';
import { HomePage } from './pages/home-page/home-page';
import { AboutUsPage } from './pages/main/about-us-page/about-us-page';
import { ContactUsPage } from './pages/main/contact-us-page/contact-us-page';
import { MainDrawerPage } from './pages/main/main-drawer-page/main-drawer-page';
import { FaqPage } from './pages/policy/faq-page/faq-page';
import { PrivacyPolicyPage } from './pages/policy/privacy-policy-page/privacy-policy-page';
import { ReturnExchangePolicyPage } from './pages/policy/return-exchange-policy-page/return-exchange-policy-page';
import { TermsOfServicePage } from './pages/policy/terms-of-service-page/terms-of-service-page';
import { ProductCollectionPage } from './pages/product/product-collection-page/product-collection-page';
import { ProductPage } from './pages/product/product-page/product-page';
import { ProductSearchPage } from './pages/product/product-search-page/product-search-page';
import { CheckoutPage } from './pages/shopping/checkout-page/checkout-page';
import { CheckoutResultPage } from './pages/shopping/checkout-result-page/checkout-result-page';
import { ShoppingCartPage } from './pages/shopping/shopping-cart-page/shopping-cart-page';

export const routes: Routes = [
  {
    path: '',
    component: MainDrawerPage,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: HomePage,
      },
      {
        path: 'about-us',
        pathMatch: 'full',
        component: AboutUsPage,
      },
      {
        path: 'contact-us',
        pathMatch: 'full',
        component: ContactUsPage,
      },
      {
        path: 'privacy-policy',
        pathMatch: 'full',
        component: PrivacyPolicyPage,
      },
      {
        path: 'faq',
        pathMatch: 'full',
        component: FaqPage,
      },
      {
        path: 'terms-of-service',
        pathMatch: 'full',
        component: TermsOfServicePage,
      },
      {
        path: 'return-and-exchange-policy',
        pathMatch: 'full',
        component: ReturnExchangePolicyPage,
      },
      {
        path: 'collection/:no',
        pathMatch: 'full',
        component: ProductCollectionPage,
      },
      {
        path: 'search',
        pathMatch: 'full',
        component: ProductSearchPage,
      },
      {
        path: 'product/:no',
        pathMatch: 'full',
        component: ProductPage,
      },
      {
        path: 'shopping/cart',
        pathMatch: 'full',
        component: ShoppingCartPage,
      },
      {
        path: 'checkout/result',
        pathMatch: 'full',
        component: CheckoutResultPage,
      },
      {
        path: 'login',
        pathMatch: 'full',
        component: LoginPage,
      },
      {
        path: 'signup',
        pathMatch: 'full',
        component: SignupPage,
      },
      {
        path: 'signup/sent',
        pathMatch: 'full',
        component: SignupSentPage,
      },
      {
        path: 'signup/verification',
        pathMatch: 'full',
        component: SignupVerificationPage,
      },
      {
        path: 'reset-password',
        pathMatch: 'full',
        component: ResetPasswordPage,
      },
    ],
  },
  {
    path: 'checkout/:id',
    pathMatch: 'full',
    component: CheckoutPage,
  },
  {
    path: 'account',
    component: AccountLayoutPage,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'profile',
      },
      {
        path: 'profile',
        pathMatch: 'full',
        component: AccountProfilePage,
      },
      {
        path: 'orders',
        pathMatch: 'full',
        component: AccountOrdersPage,
      },
    ],
  },
];
